export enum GroupEnum {
  SERRA_GAUCHA = 24,
  ESPIRITO_SANTO = 34,
  VIA_ARAUCARIA = 619,
  ECO50 = 614,
  BR381 = 622,
  CURITIBA = 601,
  SANTAMARIA = 623,
  PRF = 624,
  SIMOES_FILHO = 625
}
